/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const statusStyle ={
  lineProgressbarContainer: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  nextStepHeading: {
    color: "primary.main",
    fontWeight: 500,
  },
};

export default statusStyle;
